<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="merge-request-merge-form">
    <div class="merge-request-merge-form__content">
      <div class="form">
        <label
          for="commitMergeMessage"
          class="title"
        >
          {{ $t('labelMergeCommitField') }}
        </label>
        <textarea
          id="commitMergeMessage"
          v-model="form.mergeMessage"
          rows="4"
          class="form-control form-control-sm"
          type="text"
          :disabled="isMergeMessageDisabled"
          inputmode="text"
          :placeholder="$t('labelMergeCommitField')"
        ></textarea>
      </div>
      <div
        v-if="isSquashCommitEnabled"
        class="form"
      >
        <label class="gf-custom-checkbox">
          <input
            v-model="isSquashMessageVisible"
            type="checkbox"
          />
          <span>
            {{ $t('enableSquashCommit') }}
          </span>
        </label>
        <div v-if="isSquashMessageVisible">
          <label
            for="commitMergeMessage"
            class="title"
          >
            {{ $t('labelSquashCommitField') }}
          </label>
          <textarea
            id="commitMergeMessage"
            v-model="form.squashMessage"
            rows="4"
            class="form-control form-control-sm"
            type="text"
            :disabled="isMergeMessageDisabled"
            inputmode="text"
            :placeholder="$t('labelMergeCommitField')"
          ></textarea>
          <small class="text-muted">{{ $t('infoSquashCommit') }}</small>
        </div>
      </div>
    </div>
    <div class="merge-request-merge-form__actions">
      <gf-button
        variant="outline-secondary"
        text="Отмена"
        @click="onCancelRequest"
      />
      <gf-button
        variant="primary"
        text="Слить"
        :disabled="isSubmitDisabled"
        @click="onMergeRequest"
      />
    </div>
  </section>
</template>

<script>
import MergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';

export default {
  name: 'MergeRequestMergeForm',
  components: {
    GfButton
  },
  data() {
    return {
      form: {
        mergeMessage: null,
        squashMessage: null
      },
      isSquashMessageVisible: false,
      isSubmitDisabled: false
    };
  },
  computed: {
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest;
    },
    isMergeMessageDisabled() {
      return !this.mergeRequest?.canEditMergeCommitMessage;
    },
    isSquashCommitEnabled() {
      return this.mergeRequest?.squashCommit;
    }
  },
  mounted() {
    this.form.mergeMessage = this.mergeRequest?.defaultMergeCommitMessage;
    this.form.squashMessage = this.mergeRequest?.defaultSquashCommitMessage;
  },
  methods: {
    onCancelRequest() {
      this.$emit('cancel');
    },
    onMergeRequest() {
      if (this.isSquashCommitEnabled && !this.isSquashMessageVisible) {
        this.form.squashMessage = this.mergeRequest?.defaultSquashCommitMessage;
      }
      this.isSubmitDisabled = true;
      this.$emit('submit', this.form);
    },
    enableSubmit() {
      this.isSubmitDisabled = false;
    }
  },
  i18n: {
    messages: MergeRequestMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-request-merge-form';

#{$this} {
  display: flex;
  flex-direction: column;
  gap: 16px;

  #{$this}__content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    & .form {
      display: flex;
      flex-direction: column;
      gap: 4px;
      & label.title {
        margin-bottom: 0;
        font-weight: 550;
      }
    }
  }
  #{$this}__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}
</style>
